'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const groupPackagesForUI = (packages, packageClaims) => {
  const isSelected = shipment => packageClaims[shipment.id] !== undefined;
  return (packages ?? []).reduce((acc, shipment) => {
    if (isSelected(shipment)) {
      return {
        ...acc,
        selectedShipments: [...acc.selectedShipments, shipment]
      };
    } else if (shipment.evaluatedEligibility.isEligible) {
      return {
        ...acc,
        eligibleShipments: [...acc.eligibleShipments, shipment]
      };
    } else {
      return {
        ...acc,
        ineligibleShipments: [...acc.ineligibleShipments, shipment]
      };
    }
  }, {
    selectedShipments: [],
    eligibleShipments: [],
    ineligibleShipments: []
  });
};

exports.groupPackagesForUI = groupPackagesForUI;
